import { render, staticRenderFns } from "./SampleImage.vue?vue&type=template&id=418ef74e&scoped=true&"
import script from "./SampleImage.vue?vue&type=script&lang=js&"
export * from "./SampleImage.vue?vue&type=script&lang=js&"
import style0 from "./SampleImage.vue?vue&type=style&index=0&id=418ef74e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ef74e",
  null
  
)

export default component.exports